import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  forceRound,
  formatDateToTime,
  getLowerCaseString,
  loadCss,
  reduceCharacter,
} from "../../helpers/function";
import LoadingTable from "../components/LoadingTable";
import appConfig from "../../config/appConfig";
import Pagination from "../components/Pagination";
import EmptyTable from "../components/EmptyTable";
import HeaderTablePage from "../components/HeaderTablePage";
import { NUMBER_ELEMENT_PER_PAGE } from "../../constants/dataTable";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import HtmlDescriptionModal from "../components/DescriptionDetail/HtmlDescriptionModal";
import HtmlDescription from "../components/DescriptionDetail/HtmlDescription";
import { useTranslation } from "react-i18next";
import ls from "localstorage-slim";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const HistoricReceipts = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  document.title = "Satis client - " + (ready ? t("Paramètre Historique") : "");

  if (!verifyPermission(props.userPermissions, "history-list-receipt")) {
    window.location.href = ERROR_401;
  }
  const [load, setLoad] = useState(true);
  const [receipts, setReceipts] = useState([]);
  const [numberPage, setNumberPage] = useState(0);
  const [showList, setShowList] = useState([]);
  const [numberPerPage, setNumberPerPage] = useState(10);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [currentMessage, setCurrentMessage] = useState("");
  const [downloadingReceiptId, setDownloadingReceiptId] = useState(null);
  const [filterType, setFilterType] = useState("reference"); // reference | claimObject | claimer
  const [searchValue, setSearchValue] = useState("");

  let temp = JSON.parse(ls.get("userData"));
  let type_macro = temp.data.identite.staff?.institution.institution_type?.name;

  const fetchReceipts = (filters = {}) => {
    if (!verifyTokenExpire()) return;
    setLoad(true);
    axios
      .get(appConfig.apiDomaine + "/history/list-receipt", { params: filters })
      .then((response) => {
        const raw = response.data;
        const receiptsData = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
          ? raw.data
          : [];
        setReceipts(receiptsData);
        setShowList(receiptsData.slice(0, numberPerPage));
        setNumberPage(forceRound(receiptsData.length / numberPerPage));
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des récépissés:", error);
      })
      .finally(() => setLoad(false));
  };

  // Chargement initial
  useEffect(() => {
    fetchReceipts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const applyFilter = () => {
    const trimmed = searchValue.trim();
    const filters = {};
    if (trimmed) {
      filters.type = filterType;
      filters.key = trimmed;
    }
    setActiveNumberPage(1);
    fetchReceipts(filters);
  };

  const resetFilter = () => {
    setFilterType("reference");
    setSearchValue("");
    setActiveNumberPage(1);
    fetchReceipts();
  };

  const onChangeNumberPerPage = (e) => {
    setActiveNumberPage(1);
    setNumberPerPage(parseInt(e.target.value));
    setShowList(receipts.slice(0, parseInt(e.target.value)));
    setNumberPage(forceRound(receipts.length / parseInt(e.target.value)));
  };

  const getEndByPosition = (position) => {
    let end = numberPerPage;
    for (let i = 1; i < position; i++) {
      end = end + numberPerPage;
    }
    return end;
  };

  const onClickPage = (e, page) => {
    e.preventDefault();
    setActiveNumberPage(page);
    setShowList(
      receipts.slice(
        getEndByPosition(page) - numberPerPage,
        getEndByPosition(page)
      )
    );
  };

  const onClickNextPage = (e) => {
    e.preventDefault();
    if (activeNumberPage <= numberPage) {
      setActiveNumberPage(activeNumberPage + 1);
      setShowList(
        receipts.slice(
          getEndByPosition(activeNumberPage + 1) - numberPerPage,
          getEndByPosition(activeNumberPage + 1)
        )
      );
    }
  };

  const onClickPreviousPage = (e) => {
    e.preventDefault();
    if (activeNumberPage >= 1) {
      setActiveNumberPage(activeNumberPage - 1);
      setShowList(
        receipts.slice(
          getEndByPosition(activeNumberPage - 1) - numberPerPage,
          getEndByPosition(activeNumberPage - 1)
        )
      );
    }
  };

  const arrayNumberPage = () => {
    const pages = [];
    for (let i = 0; i < numberPage; i++) {
      pages[i] = i;
    }
    return pages;
  };

  const pages = arrayNumberPage();

  const showModal = (message) => {
    setCurrentMessage(message);
    document.getElementById("button_modal").click();
  };

  const downloadReceipt = async (claimId) => {
    if (verifyTokenExpire()) {
      setDownloadingReceiptId(claimId);
      try {
        const response = await axios.get(
          `${appConfig.apiDomaine}/download-claim-receipt/${claimId}`,
          {
            responseType: 'blob'
          }
        );
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `receipt-${claimId}.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      } catch (error) {
        console.error("Erreur lors du téléchargement du récépissé:", error);
      } finally {
        setDownloadingReceiptId(null);
      }
    }
  };

  const printBodyTable = (receipt, index) => {
    const isDownloading = downloadingReceiptId === receipt.id;
    return (
      <tr key={index} role="row" className="odd">
        <td>{receipt.reference} </td>
        <td>
          {receipt.claimer?.raison_sociale
            ? receipt.claimer?.raison_sociale
            : (receipt.claimer?.lastname ? receipt.claimer.lastname : "") +
              " " +
              (receipt.claimer?.firstname ? receipt.claimer.firstname : "")}
          {receipt.account_targeted
            ? " / " + receipt.account_targeted.number
            : receipt.account_number
            ? " / " + receipt.account_number
            : ""}
        </td>
        <td>{receipt.claim_object?.name?.["fr"] || "-"}</td>
        {/* <td style={{ textAlign: "center" }}>
          <HtmlDescription
            onClick={() =>
              showModal(receipt.description ? receipt.description : "-")
            }
          />
        </td> */}
        {/*<td>{claim.description.length > 15 ? reduceCharacter(claim.description) : claim.description}</td>*/}
        <td>
          {formatDateToTime(receipt.created_at)}
        </td>
        <td style={{ textAlign: "center" }}>
          {receipt.status === "archived" ? (
            <span className="kt-badge kt-badge--inline kt-badge--dark">
              {t("Archivé")}
            </span>
          ) : receipt.status === "closed" ? (
            <span className="kt-badge kt-badge--inline kt-badge--dark">
              {t("Clôturé")}
            </span>
          ) : receipt.status === "validated" ? (
            <span className="kt-badge kt-badge--inline kt-badge--success">
              {t("Validé")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "incomplete" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("Incomplète")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "full" ? (
            <span className="kt-badge kt-badge--inline kt-badge--primary h2">
              {t("Complète")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "transferred_to_unit" ? (
            <span className="kt-badge kt-badge--inline kt-badge--unified-dark h2">
              {t("Transférer à une unité")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "assigned_to_staff" ? (
            <span className="kt-badge kt-badge--inline kt-badge--info h2">
              {t("Assigner à un staff")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "treated" ? (
            <span className="kt-badge kt-badge--inline kt-badge--success h2">
              {t("Traité")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "considered" ? (
            <span className="kt-badge kt-badge--inline kt-badge--success h2">
              {t("Considéré")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "awaiting" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("En attente")}
            </span>
          ) : (receipt?.status ? receipt.status : "") === "unsatisfied" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("Traité et insatisfait")}
            </span>
          ) : (receipt?.status ? receipt.status : "") ===
            "transferred_to_staff_for_satisfactiion" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("En attente de mesure de satisfaction")}
            </span>
          ) : (
            <span className="kt-badge kt-badge--inline kt-badge--warning">
              {t("En cours de traitement")}
            </span>
          )}
        </td>
        <td style={{ textAlign: "center" }}>
          {isDownloading ? (
            <button
              className="btn btn-sm btn-primary"
              type="button"
              disabled
            >
              <span className="spinner-border spinner-border-sm mr-2"></span>
              {t("Téléchargement")}...
            </button>
          ) : (
            <button
              className="btn btn-sm btn-primary"
              type="button"
              onClick={() => downloadReceipt(receipt.id)}
              title={t("Télécharger le récépissé")}
            >
              <i className="la la-download"></i> {t("Télécharger")}
            </button>
          )}
        </td>
      </tr>
    );
  };

  return ready ? (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Historiques")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a
                href="#button"
                onClick={(e) => e.preventDefault()}
                className="kt-subheader__breadcrumbs-link"
              >
                {t("Historiques Récépissés")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet">
          <HeaderTablePage title={t("Historiques Récépissés")} />

          {load ? (
            <LoadingTable />
          ) : (
            <div className="kt-portlet__body">
              <div
                id="kt_table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-9 text-left">
                    <div id="kt_table_1_filter" className="dataTables_filter">
                      <div className="form-inline align-items-center">
                        <label className="mr-2 mb-0">
                          {t("Filtrer par")}:
                          <select
                            className="form-control form-control-sm ml-2"
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                          >
                            <option value="reference">{t("Référence")}</option>
                            <option value="claimObject">
                              {t("Objet de réclamation")}
                            </option>
                            <option value="claimer">{t("Réclamant")}</option>
                          </select>
                        </label>
                        <label className="ml-3 mb-0">
                          {t("Recherche")}:
                          <input
                            id="myInput"
                            type="text"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            className="form-control form-control-sm ml-2"
                            placeholder={t("Saisissez votre recherche")}
                            aria-controls="kt_table_1"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-3 d-flex align-items-start mt-2 mt-md-0">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm mr-2"
                      onClick={applyFilter}
                    >
                      {t("Filtrer")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={resetFilter}
                    >
                      {t("Réinitialiser")}
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table
                      className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
                      id="myTable"
                      role="grid"
                      aria-describedby="kt_table_1_info"
                      style={{ width: "952px" }}
                    >
                      <thead>
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "70.25px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Référence")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "80px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Réclamant")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "100px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Objets de réclamation")}
                          </th>
                          {/* <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "150px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Description de la réclamation")}
                          </th> */}
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "70.25px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Date de création")}
                            {/* {props.plan === "PRO" || type_macro === "filiale"
                              ? t("Point de service visé")
                              : t("Institution ciblée")} */}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "50px" }}
                            aria-label="Ship City: activate to sort column ascending"
                          >
                            {t("Statut")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "120px" }}
                            aria-label="Action: activate to sort column ascending"
                          >
                            {t("Action")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {receipts.length ? (
                          showList.length ? (
                            showList.map((receipt, index) =>
                              printBodyTable(receipt, index)
                            )
                          ) : (
                            <EmptyTable search={true} />
                          )
                        ) : (
                          <EmptyTable />
                        )}
                      </tbody>
                      <tfoot>
                        <tr style={{ textAlign: "center" }}>
                          <th rowSpan="1" colSpan="1">
                            {t("Référence")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Réclamant")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Objets de réclamations")}
                          </th>
                          {/* <th rowSpan="1" colSpan="1">
                            {t("Description")}
                          </th> */}
                          <th rowSpan="1" colSpan="1">
                            {t("Date de création")}
                            {/* {props.plan === "PRO" || type_macro === "filiale"
                              ? t("Point de service visé")
                              : t("Institution ciblée")} */}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Statut")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Action")}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                    <button
                      id="button_modal"
                      type="button"
                      className="btn btn-secondary btn-icon-sm d-none"
                      data-toggle="modal"
                      data-target="#message_email"
                    />
                    <HtmlDescriptionModal
                      title={"Description"}
                      message={currentMessage}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-5">
                    <div
                      className="dataTables_info"
                      id="kt_table_1_info"
                      role="status"
                      aria-live="polite"
                    >
                      {t("Affichage de")} 1 {t("à")} {numberPerPage} {t("sur")}{" "}
                      {receipts.length} {t("données")}
                    </div>
                  </div>

                  {showList.length ? (
                    <div className="col-sm-12 col-md-7 dataTables_pager">
                      <Pagination
                        numberPerPage={numberPerPage}
                        onChangeNumberPerPage={onChangeNumberPerPage}
                        activeNumberPage={activeNumberPage}
                        onClickPreviousPage={(e) => onClickPreviousPage(e)}
                        pages={pages}
                        onClickPage={(e, number) => onClickPage(e, number)}
                        numberPage={numberPage}
                        onClickNextPage={(e) => onClickNextPage(e)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};
const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(HistoricReceipts);
